export default "__VITE_ASSET__BNIBRXUw__"